angular
	.module 'App.Repository'
	.factory 'TransactionRepository',
		[
			'BaseRepository',
			(BaseRepository) ->
				class TransactionRepository extends BaseRepository
					@resource = '/transactions'
					@isRestricted = true

				return new TransactionRepository
		]
